<template>
  <div class="page-wrap" v-if="loaded">
    <Table />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Table from "./GuestSchoolDetailTableComponent.vue";

const loaded = ref(false);

onMounted(() => {
  loaded.value = true;
});
</script>

<style scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
</style>
